import { InvoicingData, InvoicingFilter } from "./invoicing-types";
import moment from "moment";

const competenceMonth = parseInt(moment().format('MM'));
const competenceYear = parseInt(moment().format('YYYY'));

export const defaultFilter = (): InvoicingFilter => ({
  competencies: null,
  carrierIds: null,
  financialGroupIds: null,
  contractIds: null,
  subContractIds: null,
  invoiceTypeIds: null,
  benefitIds: null,
  page: 0,
  size: 25,
  sort: 'updatedAt,desc'
});

export const createInvoicingData = (): InvoicingData => ({
  invoices: [],
  selectedInvoices: [],
  filter: defaultFilter(),
  loadingPage: false,
  invoicingTab: 'invoicing',
  pageMounted: false,
  showExportConfirmModal: false,
  showExportRequestModal: false,
  showDownloadHistoryModal: false,
  totalPages: null,
  totalElements: null,
});